//@ts-check
import React, {  } from 'react';
import Navbar from './Navbar';
import SubNav from './SubNav';

const Header = () => {

  return(
    <div>
      <Navbar/>
       <SubNav/>
    </div>
  )
}

export default Header 


// WEBPACK FOOTER //
// ./src/components/Header/index.jsx